import React, { useEffect, useMemo } from "react";
import { IndiaReactMap } from "../../assets/icons";

export default function IndiaMap({
  states = [],
  zones = [],
  selectedState,
  onMarkerClick,
}) {
  // Create: { "Punjab": "#4CAF50", "Haryana": "#4CAF50", ... }
  const stateLookup = useMemo(() => {
    const lookup = {};

    states?.forEach((state) => {
      const zone = zones.find((z) => z.id === state.zoneId);

      lookup[state.name] = zone?.color || "#E5E7EB";
    });

    return lookup;
  }, [states, zones]);

  useEffect(() => {
    const paths = document?.querySelectorAll("svg path");

    paths?.forEach((path) => {
      const stateName = path?.getAttribute("title");

      // Color State
      path.style.fill = stateLookup[stateName] || "#E5E7EB";

      path.style.stroke = "#fff";
      path.style.strokeWidth = "1";

      // Highlight Selected State
      if (selectedState?.name === stateName) {
        path.style.stroke = "#000";
        path.style.strokeWidth = "3";
      }

      path.style.cursor = "pointer";

      path.onclick = () => {
        const state = states.find((s) => s.name === stateName);

        if (state) {
          onMarkerClick?.(state);
        }
      };
    });
  }, [stateLookup, selectedState, states, onMarkerClick]);

  return (
    <div className="w-full flex justify-center">
      <IndiaReactMap
        style={{
          width: "100%",
          height: "auto",
        }}
      />
    </div>
  );
}
